(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collections-banner"]) return;
  try {
    
  var mySwiper = new Swiper ('.swiper-container', {
    direction: 'horizontal', // 垂直切换选项
    loop: false, // 循环模式选项
     autoplay:false,
    // 如果需要分页器
    pagination: {
      el: '.swiper-pagination',
    },

  })

  } catch(e) { console.error(e); }
})();
})();
